import React, { useRef } from 'react';
import useLazyLoad from '../hooks/useLazyLoad';

function MenuCategory({ category, menuItems, onDishClick, selectedLocation }) {
  const containerRef = useRef(null);
  useLazyLoad(containerRef, { rootMargin: '0px', threshold: 0.1 });

  const handleImageError = (e) => {
    e.target.style.display = 'none';
  };

  return (
    <section id={category.name.replace(/\s+/g, '-').toLowerCase()} className="menu-category-section">
      <h2 className="category-title">{category.name}</h2>
      <div className="menu-list" ref={containerRef}>
        {menuItems && menuItems.length > 0 ? (
          menuItems.map((dish) => (
            <div key={dish.id} className="menu-list-item" onClick={() => onDishClick(dish)}>
              {dish.imageUrl && (
                <img
                  data-src={dish.imageUrl}
                  alt={dish.name}
                  className="dish-image lazy"
                  src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" // Transparent pixel
                  onError={handleImageError}
                />
              )}
              <div className="dish-info">
                <div className="item-header">
                  <h3 className="item-name">{dish.name}</h3>
                  {selectedLocation && dish.prices && dish.prices[selectedLocation.id] !== undefined ? (
                    <span className="item-price">${dish.prices[selectedLocation.id]}</span>
                  ) : (
                    <span className="item-price">N/A</span> // Or some other placeholder
                  )}
                </div>
                {dish.description && (
                  <div className="item-description-wrapper">
                    <p className="item-description">{dish.description}</p>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <p>No hay platos disponibles en esta categoría.</p>
        )}
      </div>
    </section>
  );
}

export default MenuCategory;
